// import * as AntDIcons from '@ant-design/icons';
// import Icon from '@ant-design/icons';
import { Link, useNavigate } from "react-router-dom";
import { Layout, Menu, Modal, Select, Typography, Spin, Image } from 'antd';
import React, { useState, useEffect } from 'react';
import Utils from '../../misc/Utils';
import Enums from '../../misc/Enums';
import StickyBox from "react-sticky-box";
import SimpleBarReact from "simplebar-react";
import uuid from 'react-uuid';
import axios from 'axios';
import { StudentProfile } from '../profile/StudentProfile';
import { StaffProfile } from '../profile/StaffProfile';
import LoginService from '../../services/LoginService';

import Icon, {
   ExclamationCircleOutlined, ProjectOutlined, CloudOutlined, FileDoneOutlined, LogoutOutlined, EditOutlined, FileOutlined, TeamOutlined,
   HomeOutlined, ScheduleOutlined, CalendarOutlined, ProfileOutlined, CarryOutOutlined, ReadOutlined, BarChartOutlined, BookOutlined,
   NotificationOutlined, ControlOutlined, SolutionOutlined, ToTopOutlined, ClusterOutlined, UnorderedListOutlined, OrderedListOutlined,
   FormOutlined, IdcardOutlined, AccountBookOutlined, HistoryOutlined, AreaChartOutlined,
   DatabaseOutlined
} from '@ant-design/icons';

import ZoomPickerV2 from "../zoom-picker/ZoomPickerV2";

const { Header, Content, Footer, Sider } = Layout;


const rootSubmenuKeys = ['sub0', 'sub1', 'sub2', 'sub3', 'sub4', 'sub5'];

const { Option } = Select;
const { Text } = Typography;

const SideMenuNew = () => {
   const [collapsed, setCollapsed] = useState(true);
   const [openKeys, setOpenKeys] = useState(['1']);

   const ZoomSvg = () => (
      <svg width="1em" height="1em" viewBox="0 0 192 192" xmlns="http://www.w3.org/2000/svg" fill="none">
         <path stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="11.997" d="M16.869 60.973v53.832c.048 12.173 10.87 21.965 24.072 21.925h85.406c2.42 0 4.385-1.797 4.385-3.978V78.92c-.064-12.164-10.887-21.965-24.073-21.917H21.237c-2.412 0-4.368 1.79-4.368 3.97zm119.294 21.006 35.27-23.666c3.06-2.332 5.432-1.749 5.432 2.468v72.171c0 4.8-2.9 4.217-5.432 2.468l-35.27-23.618V81.98z" />
      </svg>
   );

   const ZoomIcon = (props) => <Icon component={ZoomSvg} {...props} />;

   var subdomain = localStorage.getItem("lms-subdomain");

   const user_id = Utils.getCurrentUserInfo(Enums.UserInfo.id);
   const user_role = Utils.getCurrentUserInfo(Enums.UserInfo.role);
   const user_other_data = JSON.parse(Utils.getCurrentUserInfo(Enums.UserInfo.otherdata));
   const picture = user_other_data.Picture !== '' ? `${process.env.REACT_APP_API_S3_URL}/${subdomain}/${user_other_data.Picture}` : "data:image/png;base64,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";
   const username = user_other_data.Username;
   const status = user_other_data.Status;

   const [updating, setUpdating] = useState(false);
   const [schoolYear, setSchoolYear] = useState(null);
   const [schoolYearList, setSchoolYearList] = useState([]);
   const [currentSchoolYear, setCurrentSchoolYear] = useState(null);

   const [schoolYearModalVisible, setSchoolYearModalVisible] = useState(false);
   const [profileModalVisible, setProfileModalVisible] = useState(false);
   const [userCanChangeUsername, setUserCanChangeUsername] = useState(true);
   const [userCanChangePassword, setUserCanChangePassword] = useState(true);
   const [hasOA, setHasOA] = useState(false);
   const [hasZoom, setHasZoom] = useState(false);

   const [zoomPickerVisible, setZoomPickerVisible] = useState(false);

   // Helper to set config state
   const setConfigState = (cfield, value) => {
      const isYes = value === 'yes';
      switch (cfield) {
         case 'STUDENT_CAN_CHANGE_USERNAME':
            setUserCanChangeUsername(isYes);
            break;
         case 'STUDENT_CAN_CHANGE_PASSWORD':
            setUserCanChangePassword(isYes);
            break;
         case 'HAS_ONLINE_APPLICATION':
            setHasOA(isYes);
            break;
         case 'HAS_ZOOM':
            setHasZoom(isYes);
            break;
         default:
            break;
      }
   };

   // Fetch all config settings in parallel
   const fetchAllConfigSettings = () => {
      const fields = [
         'STUDENT_CAN_CHANGE_USERNAME',
         'STUDENT_CAN_CHANGE_PASSWORD',
         'HAS_ONLINE_APPLICATION',
         'HAS_ZOOM'
      ];
      Promise.all(fields.map(field =>
         axios.get(`${process.env.REACT_APP_API_MANAGEMENT}/configsettingvalue?cfield=${field}`)
            .then(res => setConfigState(field, res.data))
            .catch(err => console.log(err.message))
      ));
   };

   useEffect(() => {
      function handleResize() {
         setCollapsed(true);
         fetchAllConfigSettings();
      }
      window.addEventListener('resize', handleResize);

      getCurrentSchoolYear();
      fetchAllConfigSettings();

      return () => {
         window.removeEventListener('resize', handleResize);
      };
   }, []);

   // getConfigSettingValue is now handled by fetchAllConfigSettings and setConfigState

   const getCurrentSchoolYear = () => {
      axios.get(`${process.env.REACT_APP_API_MANAGEMENT}/currentschoolyear`).then((response) => {
         if (response.data) {
            const data = response.data;
            setCurrentSchoolYear(data);
         }
      }, (error) => {
         console.log(error.message);
      });
   }



   const onOpenChange = (keys) => {
      // var latestOpenKey = '';

      // if (keys.length > 0)
      //    latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);
      // else {
      //    if (openKeys.length > 0)
      //       latestOpenKey = openKeys[0];
      // }

      const latestOpenKey = keys.find((key) => openKeys.indexOf(key) === -1);

      if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
         setOpenKeys(keys);
      } else {
         setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
      }
   };

   const { confirm } = Modal;

   const handleLogout = () => {
      LoginService.logout(username).then((response) => {
         localStorage.removeItem('lms-jwt');
         window.location.href = '/';
      });
   }

   const showConfirm = () => {
      confirm({
         centered: true,
         title: 'Are you sure you want to logout?',
         icon: <ExclamationCircleOutlined />,
         content: '',
         onOk() {
            // LoginService.logout().then((response) => {
            //    //
            // });

            // localStorage.removeItem('lms-jwt');
            // window.location.href = '/';
            handleLogout()
         },
         onCancel() {
            console.log('Cancel');
         },
      });
   }

   function getItem(label, key, icon, children) {
      return {
         key,
         icon,
         children,
         label,
      };
   }

   const moduleNotAvailable = () => {
      Modal.info({
         title: 'Brainee LMS',
         content: 'We will let you know once this module is available.',
         centered: true,
      });
   }

   const handleELibraryLink = () => {
      switch (subdomain) {
         case 'lcccaloocan':
            window.open('https://lcccaloocan-library.braineeph.com', '_blank').focus();
            break;
         case 'smapasay':
            window.open('https://smapasay-library.braineeph.com', '_blank').focus();
            break;
         case 'uvca':
            window.open('https://uvca-library.braineeph.com', '_blank').focus();
            break;
         case 'mcamandaluyong':
            window.open('https://mcamandaluyong-library.braineeph.com', '_blank').focus();
            break;
         case 'sanlorenzoschoolph':
            window.open('https://sanlorenzoschoolph-library.braineeph.com', '_blank').focus();
            break;
         case 'fiatluxacademe':
            window.open('https://flagentri-library.braineeph.com', '_blank').focus();
            break;
         case 'dba-bacolor':
            window.open('https://dba-bacolor-library.braineeph.com', '_blank').focus();
            break;
         case 'sdca':
            window.open('https://sdca-library.braineeph.com', '_blank').focus();
            break;
         default:
            moduleNotAvailable();
      }
   }

   const handleBraineeResourcesLink = () => {

      const isAllowedSubdomain = Utils.hasBraineeResourcesAccess(subdomain);

      return getItem(
         <Link to={isAllowedSubdomain ? "/brainee-resources" : "#"} onClick={isAllowedSubdomain ? undefined : moduleNotAvailable}>
            <span>Brainee Resources</span>
         </Link>, '41', <DatabaseOutlined />
      );
   }

   // Simplified GetMenuItems function
   function GetMenuItems() {
      // Helper menu items
      const logoutItem = getItem(<Link to="#" onClick={() => showConfirm()}><span>Logout</span></Link>, 'logout', <LogoutOutlined />);
      const homeItem = getItem(<Link to="/home"><span>Home</span></Link>, '1', <HomeOutlined />);
      const scheduleMenu = getItem('Schedule', 'sub0', <ScheduleOutlined />, [
         getItem(<Link to="/classsched"><span>Class Schedule</span></Link>, '2', <ScheduleOutlined />),
         getItem(<Link to="/lessoncalendar"><span>Lesson Calendar</span></Link>, '3', <CalendarOutlined />),
         getItem(<Link to="/schoolcalendar"><span>School Calendar</span></Link>, '4', <CalendarOutlined />),
      ]);
      const attendanceMenu = getItem('Attendance', 'sub2', <CarryOutOutlined />, [
         getItem(<Link to="/classroomattendance"><span>Classroom</span></Link>, '8', <ProfileOutlined />),
         getItem(<Link to="/attendance"><span>Gate</span></Link>, '9', <ProfileOutlined />),
         getItem(<Link to="classroomattendancerpt"><span>Classroom Attendance Reports</span></Link>, '48', <ProfileOutlined />),
      ]);
      const reportCardMenu = getItem('Report Card & Certificates', 'sub1', <ProfileOutlined />, [
         getItem(<Link to="/reportcards"><span>Report Card</span></Link>, '5', <ProfileOutlined />),
         getItem(<Link to="/certificates"><span>Certificate</span></Link>, '6', <ProfileOutlined />),
      ]);
      const managementMenuAdmin = getItem('Management', 'sub5', <ControlOutlined />, [
         getItem(<Link to="/managestudentinfo"><span>Student Information</span></Link>, '31', <SolutionOutlined />),
         getItem(<Link to="/promotestudents"><span>Promote Students</span></Link>, '32', <ToTopOutlined />),
         getItem(<Link to="/subjects"><span>Subjects</span></Link>, '33', <EditOutlined />),
         getItem(<Link to="/subjectgroups"><span>Subject Groups</span></Link>, '34', <ClusterOutlined />),
         getItem(<Link to="/sections"><span>Sections</span></Link>, '35', <UnorderedListOutlined />),
         getItem(<Link to="/levels"><span>Levels</span></Link>, '36', <OrderedListOutlined />),
         getItem(<Link to="/managestaffinfo"><span>Staff Information</span></Link>, '37', <TeamOutlined />),
         getItem(<Link to="/appinfogroups"><span>Application Form Sections</span></Link>, '38', <FormOutlined />),
         getItem(<Link to="/appinfofields"><span>Application Form Fields</span></Link>, '39', <FormOutlined />),
      ]);
      const managementMenuTeacher = getItem('Management', 'sub5', <ControlOutlined />, [
         getItem(<Link to="/managestudentinfo"><span>Student Information</span></Link>, '31', <IdcardOutlined />),
      ]);

      // Early returns for exclusive roles/status
      if (user_role === 'Student' && status === '0') {
         return [
            getItem(<Link to="/studentassessment"><span>Examination</span></Link>, '1', <FileDoneOutlined />),
            logoutItem,
         ];
      }
      if (user_role === 'Parent' && status === '0') {
         return [
            getItem(<Link to="/studentprofile"><span>Update Student Information</span></Link>, '2', <EditOutlined />),
            getItem(<Link to="/studentfees"><span>Tuition Fee Assessment</span></Link>, '3', <FileOutlined />),
            logoutItem,
         ];
      }
      if (user_role === 'Registrar' || user_role === 'Cashier') {
         return [
            getItem(<Link to="/applicantlist"><span>Student Applicants</span></Link>, '1', <TeamOutlined />),
            logoutItem,
         ];
      }
      if (user_role === 'Guidance') {
         return [
            getItem(<Link to="/applicantlist"><span>Student Applicants</span></Link>, '1', <TeamOutlined />),
            getItem(<Link to="/assessment"><span>Examination (LMS)</span></Link>, '2', <FileDoneOutlined />),
            logoutItem,
         ];
      }

      // Main menu for other roles
      let menu = [];

      // Sudeco special case
      if (subdomain === 'sudeco') {
         if (!['Registrar', 'Guidance', 'Cashier'].includes(user_role)) {
            menu.push(homeItem);
            if (['Admin', 'Teacher'].includes(user_role)) {
               menu.push(
                  getItem(<Link to="/classsched"><span>Class Schedule</span></Link>, '2', <ScheduleOutlined />),
                  getItem(<Link to="/reportcards"><span>Report Card</span></Link>, '5', <ProfileOutlined />)
               );
            }
         }
      } else {
         if (!['Registrar', 'Guidance', 'Cashier'].includes(user_role)) {
            menu.push(homeItem);

            if (['Admin', 'Teacher', 'Co-Teacher'].includes(user_role)) {
               menu.push(scheduleMenu);

               if (user_role !== 'Co-Teacher') {
                  menu.push(reportCardMenu);
               }

               menu.push(attendanceMenu);

               if (['Admin', 'Teacher'].includes(user_role)) {
                  const braineeLMSMenuItems = ['sbuibedmanila', 'sbuibedrizal', 'mts-bacoor', 'mts-gentri'].includes(subdomain)
                     ? [
                        getItem(<Link to="/homeworksubjects"><span>Homework & Project</span></Link>, '13', <ProjectOutlined />),
                        getItem(<Link to="/masterysubjects"><span>Brainee Mastery Assessment</span></Link>, '15', <FileDoneOutlined />),
                        getItem(<Link to="/masteryassessmentreport"><span>Mastery Assessment Reports</span></Link>, '16', <BarChartOutlined />),
                        getItem('Diagnostic Assessment', 'g1', <CalendarOutlined />, [
                           getItem(<Link to="/bdiagnostic/subjects?type=pre"><span>Pre Test</span></Link>, '17'),
                           getItem(<Link to="/bdiagnostic/subjects?type=post"><span>Post Test</span></Link>, '18'),
                           getItem(<Link to="/bdiagnostic/report"><span>Reports</span></Link>, '19'),
                        ], 'group'),
                     ]
                     : [
                        getItem(<Link to="/subject"><span>Lesson</span></Link>, '10', <ReadOutlined />),
                        getItem(<Link to="/formativeassessment/subjects"><span>Formative Assessment</span></Link>, '11', <FileDoneOutlined />),
                        getItem(<Link to="/assessment/subjects"><span>Summative Assessment</span></Link>, '12', <FileDoneOutlined />),
                        getItem(<Link to="/homeworksubjects"><span>Homework & Project</span></Link>, '13', <ProjectOutlined />),
                        getItem(<Link to="#" onClick={() => moduleNotAvailable()}><span>Lesson Reports</span></Link>, '14', <BarChartOutlined />),
                        getItem(<Link to="/masterysubjects"><span>Brainee Mastery Assessment</span></Link>, '15', <FileDoneOutlined />),
                        getItem(<Link to="/masteryassessmentreport"><span>Mastery Assessment Reports</span></Link>, '16', <BarChartOutlined />),
                        getItem('Diagnostic Assessment', 'g1', <CalendarOutlined />, [
                           getItem(<Link to="/bdiagnostic/subjects?type=pre"><span>Pre Test</span></Link>, '17'),
                           getItem(<Link to="/bdiagnostic/subjects?type=post"><span>Post Test</span></Link>, '18'),
                           getItem(<Link to="/bdiagnostic/report"><span>Reports</span></Link>, '19'),
                        ], 'group'),
                     ];
                  menu.push(getItem('Brainee LMS', 'sub3', <CloudOutlined />, braineeLMSMenuItems));
               }

               if (!['sbuibedmanila', 'sbuibedrizal'].includes(subdomain))
                  menu.push(handleBraineeResourcesLink());

               if (user_role === "Co-Teacher") {
                  menu.push(getItem('Brainee LMS', 'sub2', <CloudOutlined />, [
                     getItem(<Link to="/subject"><span>Lesson</span></Link>, '9', <ReadOutlined />),
                     getItem(<Link to="/formativeassessment/subjects"><span>Formative Assessment</span></Link>, '10', <FileDoneOutlined />),
                     getItem(<Link to="/assessment/subjects"><span>Summative Assessment</span></Link>, '11', <FileDoneOutlined />),
                     getItem(<Link to="/homeworksubjects"><span>Homework & Project</span></Link>, '12', <ProjectOutlined />),
                     getItem(<Link to="/masterysubjects"><span>Brainee Mastery Assessment</span></Link>, '13', <FileDoneOutlined />),
                     getItem(<Link to="#" onClick={() => moduleNotAvailable()}><span>Lesson Reports</span></Link>, '14', <BarChartOutlined />),
                     getItem(<Link to="/masteryassessmentreport"><span>Mastery Assessment Reports</span></Link>, '14', <BarChartOutlined />),
                  ]));
               }

               if (subdomain === 'lcccaloocan') {
                  menu.push(getItem('Brainee E-Library', 'sub3', <BookOutlined />, [
                     getItem(<Link to="#" onClick={() => window.open('https://lcccaloocangs-library.braineeph.com', '_blank').focus()}><span>Grade School</span></Link>, '26'),
                     getItem(<Link to="#" onClick={() => window.open('https://lcccaloocanjhs-library.braineeph.com', '_blank').focus()}><span>Junior High School</span></Link>, '27'),
                     getItem(<Link to="#" onClick={() => window.open('https://lcccaloocan-library.braineeph.com', '_blank').focus()}><span>Senior High School</span></Link>, '28'),
                  ]));
               } else {
                  menu.push(getItem(<Link to="#" onClick={() => handleELibraryLink()}><span>Brainee E-Library</span></Link>, '29', <BookOutlined />));
               }

               if (user_role !== 'Co-Teacher')
                  menu.push(getItem(<Link to="/notice"><span>Notice Board</span></Link>, '30', <NotificationOutlined />));
            }

            if (user_role === 'Admin') {
               menu.push(managementMenuAdmin);
            }
            if (user_role === 'Teacher') {
               menu.push(managementMenuTeacher);
            }
            if (user_role === 'Student') {
               menu.push(
                  getItem('Schedule', 'sub0', <ScheduleOutlined />, [
                     getItem(<Link to="/classsched"><span>Class Schedule</span></Link>, '2', <CalendarOutlined />),
                     getItem(<Link to="/lessoncalendar"><span>Lesson Calendar</span></Link>, '3', <CalendarOutlined />),
                     getItem(<Link to="/schoolcalendar"><span>School Calendar</span></Link>, '4', <CalendarOutlined />),
                  ]),
                  getItem('Report Card & Certificates', 'sub1', <ProfileOutlined />, [
                     getItem(<Link to="/studentreportcard"><span>Report Card</span></Link>, '5', <CalendarOutlined />),
                     getItem(<Link to="/studentcertificate"><span>Certificate</span></Link>, '6', <CalendarOutlined />),
                  ]),
                  getItem('Student Attendance', 'sub2', <ProfileOutlined />, [
                     getItem(<Link to="/classroomattendancerpt"><span>Classroom</span></Link>, '7', <CalendarOutlined />),
                     getItem(<Link to="/attendance"><span>Gate</span></Link>, '8', <CalendarOutlined />),
                  ])
               );

               const otherItems = ['sbuibedmanila', 'sbuibedrizal', 'mts-bacoor', 'mts-gentri'].includes(subdomain)
                  ? [
                     getItem(<Link to="/homeworksubjects"><span>Homework & Project</span></Link>, '13', <ProjectOutlined />),
                     getItem(<Link to="/masterysubjects"><span>Mastery Assessment</span></Link>, '15', <FileDoneOutlined />),
                     getItem(<Link to="/masteryassessmentreport"><span>Mastery Assessment Reports</span></Link>, '16', <BarChartOutlined />),
                     getItem('Diagnostic Assessment', 'g1', <CalendarOutlined />, [
                        getItem(<Link to="/bdiagnostic/student/subjects?type=pre"><span>Pre Test</span></Link>, '13'),
                        getItem(<Link to="/bdiagnostic/student/subjects?type=post"><span>Post Test</span></Link>, '14'),
                     ], 'group'),
                  ]
                  : [
                     getItem(<Link to="/subject"><span>Lesson</span></Link>, '9', <ReadOutlined />),
                     getItem(<Link to="/studentformativeassessment/subjects"><span>Formative Assessment</span></Link>, '10', <FileDoneOutlined />),
                     getItem(<Link to="/studentassessment/subjects"><span>Summative Assessment</span></Link>, '11', <FileDoneOutlined />),
                     getItem(<Link to="/studentmasteryassessment"><span>Mastery Assessment</span></Link>, '12', <FileDoneOutlined />),
                     getItem('Diagnostic Test', 'g1', <CalendarOutlined />, [
                        getItem(<Link to="/bdiagnostic/student/subjects?type=pre"><span>Pre Test</span></Link>, '13'),
                        getItem(<Link to="/bdiagnostic/student/subjects?type=post"><span>Post Test</span></Link>, '14'),
                     ], 'group'),
                     getItem(<Link to="/studenthomeworks/subjects"><span>Homework & Project</span></Link>, '15', <ProjectOutlined />)
                  ];

               menu.push(getItem('Brainee LMS', 'sub3', <CloudOutlined />, otherItems));
               menu.push(handleBraineeResourcesLink());

               if (subdomain === 'lcccaloocan') {
                  menu.push(getItem('Brainee E-Library', 'sub4', <BookOutlined />, [
                     getItem(<Link to="#" onClick={() => window.open('https://lcccaloocangs-library.braineeph.com', '_blank').focus()}><span>Grade School</span></Link>, '17'),
                     getItem(<Link to="#" onClick={() => window.open('https://lcccaloocanjhs-library.braineeph.com', '_blank').focus()}><span>Junior High School</span></Link>, '18'),
                     getItem(<Link to="#" onClick={() => window.open('https://lcccaloocan-library.braineeph.com', '_blank').focus()}><span>Senior High School</span></Link>, '19'),
                  ]));
               } else {
                  menu.push(getItem(<Link to="#" onClick={() => handleELibraryLink()}><span>Brainee E-Library</span></Link>, '17', <BookOutlined />));
               }
            }
            if (user_role === 'Parent') {
               if (hasOA)
                  menu.push(getItem(<Link to="/admission"><span>Online Enrollment</span></Link>, '3', <CloudOutlined />));
               menu.push(
                  getItem('Schedule', 'sub0', <ScheduleOutlined />, [
                     getItem(<Link to="/classsched"><span>Class Schedule</span></Link>, '4', <CalendarOutlined />),
                     getItem(<Link to="/lessoncalendar"><span>Lesson Calendar</span></Link>, '5', <CalendarOutlined />),
                     getItem(<Link to="/schoolcalendar"><span>School Calendar</span></Link>, '6', <CalendarOutlined />),
                  ]),
                  getItem('Report Card & Certificates', 'sub1', <CalendarOutlined />, [
                     getItem(<Link to="/studentreportcard"><span>Report Card</span></Link>, '6', <CalendarOutlined />),
                     getItem(<Link to="/studentcertificate"><span>Certificate</span></Link>, '8', <CalendarOutlined />),
                  ]),
                  getItem('Student Attendance', 'sub2', <ProfileOutlined />, [
                     getItem(<Link to="/classroomattendancerpt"><span>Classroom</span></Link>, '9', <CalendarOutlined />),
                     getItem(<Link to="/attendance"><span>Gate</span></Link>, '10', <CalendarOutlined />),
                  ]),
                  getItem(<Link to="/studenthomeworks/subjects"><span>Homework & Project</span></Link>, '10', <ProjectOutlined />)
               );
               if (['sbuibedmanila', 'sbuibedrizal', 'mts-bacoor', 'mts-gentri'].includes(subdomain)) {
                  menu.push(getItem('Student Records', 'sub3', <AccountBookOutlined />, [
                     getItem(<Link to="#" onClick={() => moduleNotAvailable()}><span>Student Information</span></Link>, '11', <ProfileOutlined />),
                     getItem(<Link to="#" onClick={() => moduleNotAvailable()}><span>Payment History</span></Link>, '13', <HistoryOutlined />),
                  ]));
               }
               else {
                  menu.push(getItem('Student Records', 'sub3', <AccountBookOutlined />, [
                     getItem(<Link to="#" onClick={() => moduleNotAvailable()}><span>Student Information</span></Link>, '11', <ProfileOutlined />),
                     getItem(<Link to="/soa"><span>Statement of Accounts</span></Link>, '12', <AccountBookOutlined />),
                     getItem(<Link to="#" onClick={() => moduleNotAvailable()}><span>Payment History</span></Link>, '13', <HistoryOutlined />),
                  ]));
               }
            }
            if (user_role === 'Admin') {
               menu.push(getItem(<Link to="/surveyassign"><span>Survey Assignment</span></Link>, '42', <AreaChartOutlined />));
            }
            if (user_role === 'Student') {
               menu.push(getItem(<Link to="/survey"><span>Survey</span></Link>, '43', <AreaChartOutlined />));
            }
            if (hasZoom && ['Admin', 'Teacher'].includes(user_role)) {
               menu.push(getItem(<Link to="#" onClick={() => setZoomPickerVisible(true)}><span>Zoom Picker</span></Link>, '44', <ZoomIcon />));
            }
         }
      }

      menu.push(logoutItem);
      return menu;
   }

   const handleSetCollapse = () => {
      setCollapsed(true);

      //--Clear search keys
      localStorage.removeItem('mastery-report-search-keys');
      localStorage.removeItem('mastery-assessment-search-keys');
   }

   const handleChangeSchoolYear = () => {
      setUpdating(true);

      var url = `${process.env.REACT_APP_API_MANAGEMENT}/changeschoolyear?schoolyear=${schoolYear}`;
      axios.post(url).then(response => {
         console.log(response);
         if (response.data) {
            const data = response.data;

            setUpdating(false);
            // setSchoolYearModalVisible(false);
            setCurrentSchoolYear(schoolYear);
            Modal.success({
               title: 'Change School Year',
               content: 'Changing school year successful!',
               centered: true,
               onOk: () => { setSchoolYearModalVisible(false) },
            });
         }
      }, (error) => {
         console.log(error.message);
         setUpdating(false);
         // setSchoolYearModalVisible(false);
         Modal.error({
            title: 'Change School Year',
            content: error.response.data,
            centered: true,
         });
      });
   }

   const handleShowSchoolYearModal = () => {
      axios.get(`${process.env.REACT_APP_API_LOOKUP}/schoolyearlist`).then((response) => {
         if (response.data) {
            const data = response.data;
            var tmp = [];
            data.map((item) => {
               let obj = { 'value': item.value, 'name': item.name }
               tmp.push(obj);
            });

            setSchoolYearList(tmp);
            setSchoolYearModalVisible(true);
         }
      }, (error) => {
         console.log(error.message);
      });
   }

   const handleShowProfile = () => {
      setProfileModalVisible(true);
   }

   const handleCancel = () => {
      setProfileModalVisible(false);
   }

   return (
      <>
         <nav className='menu-area'>
            <Layout hasSider>
               <Sider
                  collapsible
                  collapsed={collapsed}
                  // onCollapse={(value) => setCollapsed(value)}
                  onMouseEnter={() => setCollapsed(false)}
                  onMouseLeave={() => setCollapsed(true)}
                  // style={{
                  //    overflow: 'auto',
                  //    height: '100vh',
                  //    position: 'fixed',
                  //    left: 0,
                  //    top: 0,
                  //    // bottom: 48,
                  //    bottom: 0,
                  //    backgroundColor: '#eaf5f7',
                  //    boxShadow: '1px 0px 8px rgba(0, 0, 0, 0.5)',
                  // }}
                  style={!collapsed ? {
                     overflow: 'auto',
                     height: '100vh',
                     position: 'fixed',
                     left: 0,
                     top: 0,
                     // bottom: 48,
                     bottom: 0,
                     backgroundColor: '#b0f2fc',
                     boxShadow: '1px 0px 8px rgba(0, 0, 0, 0.5)',
                  } : {
                     overflow: 'auto',
                     // height: 'calc(100vh-48px)',
                     height: '100vh',
                     position: 'fixed',
                     left: 0,
                     top: 0,
                     // bottom: 48,
                     bottom: 0,
                     backgroundColor: '#b0f2fc',
                  }}
                  width={'280px'}
                  trigger={null}
               >
                  <StickyBox style={{ zIndex: 1000000 }}>
                     <div style={{ width: '100%', paddingLeft: "12px", paddingTop: "14px", paddingBottom: "16px", paddingRight: '10px', background: '#b0f2fc', display: 'inline-flex', justifyContent: 'space-between' }}>
                        {collapsed
                           ?
                           <img width={"41"} height={"40"} src="/images/logo_new_small.png" alt="" />
                           :
                           <>
                              {
                                 user_role === 'Admin'
                                    ?
                                    <img width={"177"} height={"40"} src="/images/logo_new.png" alt="" style={{ cursor: "pointer" }} onClick={() => { handleShowSchoolYearModal() }} />
                                    :
                                    <img width={"177"} height={"40"} src="/images/logo_new.png" alt="" />
                              }

                              {
                                 user_role === 'Parent'
                                    ?
                                    <Link to="/profile" >
                                       <img
                                          width={"45"}
                                          height={"45"}
                                          src={picture}
                                          alt=""
                                          style={{ borderRadius: '50%' }}
                                       />
                                    </Link>
                                    :
                                    <img
                                       onClick={() => handleShowProfile()}
                                       width={"45"}
                                       height={"45"}
                                       src={picture}
                                       alt=""
                                       style={{ borderRadius: '50%', cursor: 'pointer' }}
                                    />
                              }

                           </>
                        }
                     </div>
                  </StickyBox>
                  <SimpleBarReact style={{ height: 'calc(100vh - 80px' }}>
                     <Menu
                        style={{ background: '#b0f2fc' }}
                        // height='80%'
                        // theme="dark"
                        // mode="vertical"
                        mode="inline"
                        openKeys={openKeys}
                        onOpenChange={onOpenChange}
                        defaultSelectedKeys={['1']}
                        items={GetMenuItems()}
                        onClick={() => handleSetCollapse()}
                     />
                  </SimpleBarReact>
               </Sider>

            </Layout>
         </nav >

         <Modal
            title={<div><Image src='../images/brainee_mascot.png' preview={false} height="30px" width="28px" /> Change School Year</div>}
            centered
            destroyOnClose={true}
            onCancel={() => { setSchoolYearModalVisible(false); }}
            onOk={() => { handleChangeSchoolYear(); }}
            open={schoolYearModalVisible}
            okButtonProps={{ shape: 'round', type: 'primary' }}
            cancelButtonProps={{ shape: 'round' }}
            okText={'Change'}
         >
            <>
               <Spin spinning={updating} tip={"Changing, please wait..."}>
                  {
                     schoolYearList.length > 0 &&
                     <Select
                        showArrow
                        size='middle'
                        style={{ width: '100%', marginTop: "5px" }}
                        allowClear
                        placeholder="Select School Year"
                        // value={currentSchoolYear}
                        defaultValue={currentSchoolYear}
                        onChange={(val) => setSchoolYear(val)}
                     >

                        {schoolYearList.map(({ value, name }, idx) => {
                           return <Option value={value}>{name}</Option>;
                        })}
                     </Select>
                  }
               </Spin>
            </>
         </Modal>

         <Modal
            title={"My Profile"}
            centered
            destroyOnClose={true}
            onCancel={() => { setProfileModalVisible(false); }}
            open={profileModalVisible}
            okButtonProps={{ style: { display: 'none' } }}
            cancelButtonProps={{ style: { display: 'none' } }}
            okText={'Close'}
            width='75%'
            // footer={null}
            style={{ minWidth: '400px' }}
         >
            {
               user_role === 'Admin' || user_role === 'Teacher' || user_role === 'Registrar'
                  ?
                  <StaffProfile
                     staffID={user_id}
                     onCancelCallback={handleCancel}
                  />
                  :
                  <StudentProfile
                     studentID={user_id}
                     onCancelCallback={handleCancel}
                     canChangeUsername={userCanChangeUsername}
                     canChangePassword={userCanChangePassword}
                  />
            }
         </Modal>

         <Modal
            key="zoom-picker-modal"
            title={<div><Image src='../images/brainee_mascot.png' preview={false} height="30px" width="28px" />Zoom Picker</div>}
            destroyOnClose={true}
            centered
            open={zoomPickerVisible}
            onOk={() => setZoomPickerVisible(false)}
            onCancel={() => setZoomPickerVisible(false)}
            okText={'Close'}
            okButtonProps={{ style: { borderRadius: '7px' } }}
            cancelButtonProps={{ style: { display: 'none' } }}
            width='30%'
            style={{ minWidth: "300px" }}
         >
            <ZoomPickerV2 />
         </Modal>
      </>
   )
};

export default () => <SideMenuNew />;
